module.exports = __webpack_public_path__ + "static/img/wiseBrainIcon2.4289050.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/wiseBrainIcon2.png
// module id = A2z8
// module chunks = 1